import { FC } from "react";

import __ from "web/Layout/Translations";

import downloadFile from "web/api/downloadFile";

import ActivityItemMUI, { IActivityItemProps } from "../activityItemMUI";

export interface IFileDownloaderActivityItem extends IActivityItemProps {
  file: string;
}

const FileDownloaderActivityItemMUI: FC<IFileDownloaderActivityItem> = ({
  file,
  name,
  ...restProps
}) => {
  const onDownloadFileHandler = () => {
    downloadFile(file, name, true);
  };

  return (
    <ActivityItemMUI {...restProps} name={name} onClick={onDownloadFileHandler}>
      {__("Pobierz")}
    </ActivityItemMUI>
  );
};

export default FileDownloaderActivityItemMUI;
